import React from 'react';

interface TextareaProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  id?: string;
  rows?: number;
  cols?: number;
  maxLength?: number;
  resize?: 'none' | 'both' | 'horizontal' | 'vertical';
}

export const Textarea: React.FC<TextareaProps> = ({
  placeholder,
  value,
  onChange,
  className = '',
  required = false,
  disabled = false,
  name,
  id,
  rows = 3,
  cols,
  maxLength,
  resize = 'vertical',
}) => {
  const resizeClass = {
    none: 'resize-none',
    both: 'resize',
    horizontal: 'resize-x',
    vertical: 'resize-y'
  }[resize];

  const baseClasses = `
    w-full px-4 py-3 
    text-gray-900 dark:text-gray-100 text-sm
    bg-white dark:bg-gray-800
    border-2 border-gray-200 dark:border-gray-600
    rounded-xl
    placeholder-gray-400 dark:placeholder-gray-500
    transition-all duration-200 ease-in-out
    focus:outline-none 
    focus:border-blue-500 dark:focus:border-blue-400
    focus:ring-4 
    focus:ring-blue-100 dark:focus:ring-blue-900
    hover:border-gray-300 dark:hover:border-gray-500
    disabled:bg-gray-50 dark:disabled:bg-gray-700
    disabled:text-gray-500 dark:disabled:text-gray-400
    disabled:border-gray-200 dark:disabled:border-gray-600
    disabled:cursor-not-allowed
    ${resizeClass}
  `.replace(/\s+/g, ' ').trim();

  return (
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`${baseClasses} ${className}`}
      required={required}
      disabled={disabled}
      name={name}
      id={id}
      rows={rows}
      cols={cols}
      maxLength={maxLength}
    />
  );
};
